import { createSelector } from "reselect";

import Course from "../models/state/courses/course/Course";
import { SectionId, Sections } from "../models/state/sections/Sections";
import { getSectionNumber } from "./getSectionNumber";
import { getAllSections, getCourse } from "./state";

type State = any;

export function makeGetAllSectionNumbers(
  courseId: string,
  sectionIds: string[]
): (state: State) => { [sectionId: string]: string } {
  return createSelector(
    (state: any) => getCourse(state, courseId),
    getAllSections,
    (course, sections) => getAllSectionNumbers(course, sections, sectionIds)
  );
}

export function getAllSectionNumbers(
  course: Course,
  sections: Sections,
  sectionIds: SectionId[]
): { [sectionId: string]: string } {
  return sectionIds.reduce(
    (acc, sectionId) => ({
      ...acc,
      [sectionId]: getSectionNumber(course, sections, sectionId)
    }),
    {}
  );
}
